import { RequestService } from '../../../../common/services/RequestService';
import { GET_POSITIONS } from '../constants';

export const getPositionsRepresentatives = payload => {
  return RequestService.get(GET_POSITIONS);
};
